module.exports = __webpack_public_path__ + "img/3-dictionary-icon.d357b61b.svg";